let baseurl = ""//测试地址
// console.log(process.env, 'process.env')
switch (process.env.NODE_ENV) {
  case 'local':
    baseurl = 'https://api.dchljs.com' // 测试地址
    break
  case 'development'://开发环境
    if (window) {
      // window.console.log = function () {}
    }
    baseurl = 'https://api.dchljs.com' // 测试地址
    break
  case 'production'://生产环境
    if (window) {
      window.console.log = function () { }
    }
    baseurl = 'https://api.dchljs.com' // 正式地址
    break
}
export default {
  baseurl,
}